import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Settings } from "lucide-react";
export default function TechSolutionsTailoredForYou() {
  return <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Card className="max-w-3xl mx-auto border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 px-6">
          <CardHeader className="text-center">
            <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-primary/10">
              <Settings className="size-6 text-primary" />
            </div>
            <CardTitle className="text-2xl font-bold text-foreground">
              Technical/Systems Setup & Support
            </CardTitle>
            <CardDescription className="text-muted-foreground mt-2">
              Streamline your internal operations with customized technical solutions. We implement and refine software tools like CRM, ticketing systems, and project management platforms to enhance productivity and efficiency.
            </CardDescription>
          </CardHeader>
          <CardContent className="text-center">
            <p className="text-sm text-muted-foreground">
              From setup to ongoing support, we ensure your systems are optimized for success.
            </p>
          </CardContent>
          <CardFooter className="justify-center">
            <Link to="/ContactPage">
              <Button className="btn-primary">
                Get Started
              </Button>
            </Link>
          </CardFooter>
        </Card>
      </div>
    </section>;
}